export default __webpack_public_path__ + "static/media/marketplace.59f45edc.webp";